function isSwitzerland(val) {
    return val.valueCode === 'CH' || (val.valueCode === null && val.value === 'CH');
}
export function sortCountries(v1, v2) {
    if (isSwitzerland(v1)) {
        return -1;
    }
    if (isSwitzerland(v2)) {
        return 1;
    }
    if (v1.count !== v2.count) {
        return v2.count - v1.count;
    }
    return v1.value.toString().localeCompare(v2.value.toString());
}
